<template>

</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import UnitIcon from "course-player/components/skin/UnitIcon";

    export default {
        name: "CourseContentsTemplateMixin",
        data () {
            return {
                unitsInfo: {
                    'ebook' : {
                        'iconClasses': 'fas fa-book',
                        'imgSrc' : "contents-ebook",
                        'label':'ebook',
                        'dataKey' : 'ebooks',
                        'defaultSubtitle': 'ebook',
                        'extraInfoKey': 'readTime',
                        'isCountedAs' : "ebookCount"
                    },
                    'ivideo' : {
                        'iconClasses': 'fas fa-video',
                        'label': 'video',
                        'imgSrc' : "contents-video",
                        'dataKey' : 'videos',
                        'defaultSubtitle': 'video',
                        'extraInfoKey': 'duration',
                        'isCountedAs' : "videoCount"
                    },
                    'pdf' : {
                        'iconClasses': 'fas fa-file-pdf',
                        'defaultSubtitle': 'pdf',
                        'imgSrc' : "contents-pdf",
                        'label': 'pdf',
                        'isCountedAs' : "pdfCount"
                    },
                    'youtube' : {
                        'iconClasses': 'fab fa-youtube',
                        'imgSrc' : "contents-yt",
                        'label': 'youtube',
                        'defaultSubtitle': 'youtube',
                        'isCountedAs' : "videoCount"
                    },
                    'soundcloud' : {
                        'iconClasses': 'fab fa-soundcloud',
                        'imgSrc' : "contents-soundcloud",
                        'defaultSubtitle': 'soundcloud',
                        'label': 'soundcloud'
                    },
                    'audio' : {
                        'iconClasses': 'fas fa-volume-up',
                        'label': 'audio',
                        'imgSrc' : "contents-sound",
                        'extraInfoKey': 'duration',
                        'defaultSubtitle': 'audio',
                    },
                    'quizFormal' : {
                        'iconClasses': 'fas fa-clipboard-list',
                        'label': 'quizFormal',
                        'extraInfoKey' : 'questionsCount',
                        'defaultSubtitle': 'exam',
                        'imgSrc' : "contents-exam",
                        'isCountedAs': 'questionnairesCount',
                    },
                    'embed' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'embed',
                        'defaultSubtitle': 'embed',
                        'imgSrc' : "contents-embed",
                    },
                    'url' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'url',
                        'imgSrc' : "contents-url",
                        'defaultSubtitle': 'external page',
                    },
                    'slideshare' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'slideshare',
                        'imgSrc' : "contents-ss",
                        'defaultSubtitle': 'slideshare',
                    },
                    'scorm' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'scorm',
                        'imgSrc' : "contents-scorm",
                        'defaultSubtitle': 'scorm',
                        'isCountedAs': 'scormCount',
                    },
                    'colMooc' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'colMooc',
                        'defaultSubtitle': 'colMOOC',
                    },
                    'quizInformal' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'quizInformal',
                        'extraInfoKey' : 'questionsCount',
                        'imgSrc' : "contents-quiz",
                        'defaultSubtitle': 'quiz',
                        'isCountedAs': 'questionnairesCount',
                    },
                    'quizWritten' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'quizWritten',
                        'extraInfoKey' : 'questionsCount',
                        'imgSrc' : "contents-written",
                        'defaultSubtitle': 'assignment',
                        'isCountedAs': 'assignmentsCount',
                    },
                    'survey' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'survey',
                        'defaultSubtitle': 'survey',
                    },
                    'certificate' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'certificate',
                        'extraInfoKey' : 'questionsCount',
                        'defaultSubtitle': 'certificate',
                        'imgSrc' : "contents-certification",
                        'isCountedAs' : "certificatesCount"
                    },
                    'certificateCompletion' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'certificateCompletion',
                        'extraInfoKey' : 'questionsCount',
                        'defaultSubtitle': 'certificate of completion',
                        'imgSrc' : "contents-certification2",
                        'isCountedAs' : "certificatesCount"
                    },
                    'badge' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'badge',
                        'defaultSubtitle': 'challenge',
                    },
                    'html' : {
                        // 'iconClasses': 'fas fa-clipboard-list',
                        'label': 'html',
                        'defaultSubtitle': 'simple text',
                    }
                },
                'accessDefaults' : {
                    'private' : 'draft',
                    'soon' : 'soon',
                    'premium' : 'paid',
                    'public' : 'free'
                }
            }
        },
        props: {
            sectionData: {
                type: Object,
                required: true
            },
            courseData: {
                type: Object,
                required: true,
            },
            index : {
                type: Number,
                required: true
            },
            authoringMode: {
                type: Boolean,
                required: true,
            },
            displayAccessLabel: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapState('user',[
                'user'
            ]),
            ...mapState([
                'imagePath',
                'serverImg',
            ]),
            sectionWrapperClass () {
                return {
                    "drip-feed-section" : this.sectionHasDripFeed ,
                    "open-drip-section": this.sectionDripFeedStatus === "opened",
                    "toopen-drip-section": this.sectionDripFeedStatus === "next",
                    "notopen-drip-section": this.sectionDripFeedStatus === "closed",
                };
            },
            sectionShouldRender () {
                return this.sectionAccess !== 'private' &&  ( this.sectionHasDripFeed && this.sectionAccess !== 'soon');
            },
            sectionNumber () {
                return this.index >= 9 ? this.index + 1 : `0${this.index + 1}`;
            },
            sectionNumberDisplay () {
                return this.courseData.coursePlayerSettings && this.courseData.coursePlayerSettings.sectionNumbers;
            },
            sectionTitle () {
                return this.sectionData.title.substring( this.sectionData.title.indexOf(".")+1,100);
            },
            sectionDescription () {
                return this.sectionData.description;
            },
            sectionUnits () {
                return this.sectionData.learningPath;
            },
            sectionAccess () {
                return this.sectionData.access;
            },
            sectionIsDripLocked () {
                if (this.dripFeed && typeof this.courseData.me.drip !== "undefined" &&
                    typeof this.courseData.me.drip.sections !== "undefined" &&
                    typeof this.courseData.me.drip.sections[this.sectionData.titleId] !== "undefined" &&
                    this.courseData.me.drip.sections[this.sectionData.titleId].status !== "opened"
                ) {
                    return true;
                }

                return false
            },
            sectionLocked () {
                return ((typeof this.user.meli !=='undefined' && this.user.meli%2==0 && this.sectionData.access=='premium') ||
                    (!this.authoringMode && (typeof this.user.meli ==='undefined' || this.user.meli%2!==0) &&
                        this.sectionData.access=='premium' && !this.courseData.me.premium)
                );
            },
            sectionDisplayedAccessLabel () {
                return typeof window.LWTranslate.get("course." + this.accessDefaults[this.sectionAccess]) !== "undefined" ? window.LWTranslate.get("course." + this.accessDefaults[this.sectionAccess]) : this.accessDefaults[this.sectionAccess]
            },
            sectionHasDripFeed () {
                return !!this.sectionDripFeedType;
            },
            sectionDripFeedType () {
                return this.courseData.dripFeed === "date" || this.courseData.dripFeed === "days" ? this.courseData.dripFeed : null;
            },
            sectionDripDateLabel () {
                if (!this.sectionHasDripFeed) {
                    return '';
                }

                if (
                    this.sectionDripFeedType === 'date' ||
                    (this.sectionDripFeedType === 'days' && typeof this.sectionDripUserInfo?.type === "undefined")
                ) {
                    return this.sectionDripByDateLabel;
                } else if (this.sectionDripFeedType === 'days') {
                    return this.sectionDripByDaysLabel;
                }

                return "";
            },
            sectionDripUserInfo () {
                return this.courseData.me?.drip?.sections[this.sectionData.titleId];
            },
            sectionDripByDaysLabel () {
                let translatedText = "";
                if ( this.sectionHasDripFeed && this.sectionDripUserInfo) {


                    if (this.sectionDripUserInfo.type === 'weeks') {
                        let daysFixed = this.sectionDripUserInfo.days;

                        if (!this.authoringMode) {
                            // Fix gia to days, otan trabame course me author-contents tote exei ginei idi to /7
                            daysFixed = daysFixed / 7;
                        }

                        if (daysFixed !== 1) {
                            translatedText = window.LWTranslate.get("course.in_weeks");
                        } else {
                            translatedText = window.LWTranslate.get("course.in_week");
                        }

                        translatedText = translatedText.replace("{X}",daysFixed);
                    } else {
                        if (this.sectionDripUserInfo.days != 1) {
                            translatedText = window.LWTranslate.get("course.in_days");
                        } else {
                            translatedText = window.LWTranslate.get("course.in_day");
                        }

                        translatedText =  translatedText.replace("{X}",this.sectionDripUserInfo.days);
                    }

                }

                return translatedText;
            },
            sectionDripByDateLabel () {
                let formattedLabel = "";

                if ( this.sectionHasDripFeed && this.sectionDripUserInfo) {
                    formattedLabel = window.LWTranslate.formatTimestampLocalized(this.sectionDripUserInfo.date_user);
                }

                return formattedLabel;
            },
            dripFeedTagsDisplay () {
                return this.sectionHasDripFeed && this.sectionDripFeedStatus !== "opened" && this.sectionDripUserInfo;
            },
            sectionDripFeedStatus () {
                return this.sectionHasDripFeed && this.sectionDripUserInfo ?  this.sectionDripUserInfo.status : "";
            },
            sectionUnitsCount () {
                let unitCount = {};

                let unitCountData = this.sectionData.learningPath.map( (unitData,index) => {
                    if (this.unitsInfo[unitData.type] && this.unitsInfo[unitData.type].isCountedAs) {
                        let key = this.unitsInfo[unitData.type].isCountedAs;
                        if (typeof unitCount[key] === "undefined") {
                            unitCount[key] = 1;
                        } else {
                            unitCount[key] = unitCount[key]+ 1;
                        }
                    }
                })

                return unitCount;
            },
            sectionUnitsCountLabel () {
                let textToShow = [];
                let videoTranslation = "";
                let pdfTranslation = "";
                let certificateTranslation = "";
                let assignmentTranslation = "";
                let questionnaireTranslation = "";
                let ebookTranslation = "";
                let scormTranslation = "";


                if (this.sectionUnitsCount.videoCount >= 1) {
                    videoTranslation = this.sectionUnitsCount.videoCount + " " + window.LWTranslate.get('course.video');
                    textToShow.push(videoTranslation);
                }

                if (this.sectionUnitsCount.pdfCount >= 1) {
                    pdfTranslation = this.sectionUnitsCount.pdfCount + " " + window.LWTranslate.get('course.pdf');
                    textToShow.push(pdfTranslation);
                }

                if (this.sectionUnitsCount.ebookCount > 1) {
                    ebookTranslation =  this.sectionUnitsCount.ebookCount + " " + window.LWTranslate.get('course.ebooks');
                    textToShow.push(ebookTranslation);

                } else if (this.sectionUnitsCount.ebookCount === 1) {
                    ebookTranslation = this.sectionUnitsCount.ebookCount + " " + window.LWTranslate.get('course.ebook');
                    textToShow.push(ebookTranslation);
                }

                if (this.sectionUnitsCount.certificatesCount > 1) {
                    certificateTranslation = this.sectionUnitsCount.certificatesCount + " " + window.LWTranslate.get('course.certificates');
                    textToShow.push(certificateTranslation);
                } else if (this.sectionUnitsCount.certificatesCount === 1) {
                    certificateTranslation = this.sectionUnitsCount.certificatesCount + " " + window.LWTranslate.get('course.certificate');
                    textToShow.push(certificateTranslation);
                }

                if (this.sectionUnitsCount.assignmentsCount > 1) {
                    assignmentTranslation = this.sectionUnitsCount.assignmentsCount + " " + window.LWTranslate.get('course.assignments');
                    textToShow.push(assignmentTranslation);
                } else if (this.sectionUnitsCount.assignmentsCount === 1) {
                    assignmentTranslation = this.sectionUnitsCount.assignmentsCount + " " + window.LWTranslate.get('course.assignment');
                    textToShow.push(assignmentTranslation);
                }

                if (this.sectionUnitsCount.questionnairesCount > 1) {
                    questionnaireTranslation = this.sectionUnitsCount.questionnairesCount + " " + window.LWTranslate.get('course.questionnaires');
                    textToShow.push(questionnaireTranslation);

                } else if (this.sectionUnitsCount.questionnairesCount === 1) {
                    questionnaireTranslation = this.sectionUnitsCount.questionnairesCount + " " + window.LWTranslate.get('course.questionnaire');
                    textToShow.push(questionnaireTranslation);
                }

                if (this.sectionUnitsCount.scormCount > 0 ) {
                    scormTranslation = this.sectionUnitsCount.scormCount + ' scorm';
                    textToShow.push(scormTranslation);
                }

                return textToShow.join(', ');
            }
        },
        methods: {
            getUnitInfo (unitData) {
                return this.unitsInfo[unitData.type] ? this.unitsInfo[unitData.type] : {};
            },
            getFullUnitData (unitData) {
                let dataKey = this.getUnitInfo(unitData) && this.getUnitInfo(unitData).dataKey ? this.getUnitInfo(unitData).dataKey : "objects";
                // console.log("fulldata for unit : " , unitData , "  from : " , dataKey , this.courseData[dataKey][unitData.id]);
                return this.courseData[dataKey][unitData.id] ? this.courseData[dataKey][unitData.id] : null;
            },
            getUnitExtraInfo (unitData) {
                let unitInfo = this.getUnitInfo(unitData);

                if (unitInfo && unitInfo.extraInfoKey) {
                    return this.formatExtraInfo(unitInfo.extraInfoKey , unitData);
                }

                return ""
            },
            getSubscriptionIntervalLabel (subscription) {
                return window.LWTranslate.get('common.' + subscription.interval_type) ? window.LWTranslate.get('common.' + subscription.interval_type) : subscription.interval_type;
            },
            getUnitBackgroundImageStyle (unitData) {
                return unitData && unitData.image ?  `background-image: url('${this.serverImg + unitData.image }');` : "";
            },
            formatExtraInfo (extraInfoKey,unitData) {
                if (extraInfoKey === 'duration') {
                    let duration = unitData.type === "audio" ? this.getFullUnitData(unitData)["data"][extraInfoKey]: this.getFullUnitData(unitData)[extraInfoKey];
                    return  window.secondsTohhmmss(duration);
                } else if (extraInfoKey === 'readTime') {

                    this.getFullUnitData(unitData)['readTimeManual'] ?
                        window.secsToMinutes(this.getFullUnitData(unitData)['readTimeManual']) :
                        window.secsToMinutes(this.getFullUnitData(unitData)[extraInfoKey]) ?
                            window.secsToMinutes(this.getFullUnitData(unitData)[extraInfoKey]) :
                            "0:00";

                } else if (extraInfoKey === 'questionsCount') {
                    let questionsCount =  this.getFullUnitData(unitData)[extraInfoKey] ? this.getFullUnitData(unitData)[extraInfoKey] : "0";
                    return `${questionsCount} ${window.LWTranslate.get('course.questions')}`;
                }
            },

            unitCompleted (unitData) {
                return  this.courseData.me &&  typeof this.courseData.me.unitProgress !== "undefined" &&
                        typeof this.courseData.me.unitProgress[unitData.id] !== "undefined" &&
                        this.courseData.me.unitProgress[unitData.id].completed;
            },
            unitClicked (unit,event) {
                let data = {
                    unit,
                    sectionData: this.sectionData,
                    event
                };
                this.emitAction('unit-clicked',data);
            },
            sectionClicked () {
                let data = {
                    sectionData: this.sectionData,
                    sectionDripFeedStatus : this.sectionDripFeedStatus
                };

                this.emitAction('section-clicked',data);
            },

        },
        components: {
            UnitIcon
        }
    }
</script>

